import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';

import { ErrorsSection, LoadingWithDescription } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import { REPORT_LABOR_INSURANCE_DECLARATION_RECALCULATION_FORM } from 'src/constants/FormNames';
import {
  recalculateReportLaborInsuranceSummaryList,
  getRecalculateReportLaborInsuranceSummaryListErrors
} from 'src/reducers/reports/reportLaborInsurances';

const ConfirmRecalcurateSummaryListInsideForm = ({
  handleSubmit,
  submitting,
  submit,
  cancelBtnClick,
  errors,
  header
}) => (
  <React.Fragment>
    <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
    <CommonModal.Body>
      <form onSubmit={handleSubmit}>
        <ErrorsSection errors={errors} />
        {submitting && <LoadingWithDescription text="再計算中です。少々お待ちください。" />}
        {!submitting && (
          <div>
            確定した給与・賞与を基に再計算を行います。<br />編集したデータは失われますがよろしいですか。
          </div>
        )}
      </form>
    </CommonModal.Body>
    <CommonModal.Footer>
      <Button onClick={cancelBtnClick} className="u-mr20">
        キャンセル
      </Button>
      <FormSubmitBtn text="再計算" {...{ submitting, submit }} />
    </CommonModal.Footer>
  </React.Fragment>
);

let ConfirmRecalcurateSummaryListForm = reduxForm({
  form: REPORT_LABOR_INSURANCE_DECLARATION_RECALCULATION_FORM
})(ConfirmRecalcurateSummaryListInsideForm);
const mapStateToProp = state => ({
  errors: getRecalculateReportLaborInsuranceSummaryListErrors(state)
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  onSubmit: () => dispatch(recalculateReportLaborInsuranceSummaryList(ownProps))
});

ConfirmRecalcurateSummaryListForm = connect(mapStateToProp, mapDispatchToProp)(ConfirmRecalcurateSummaryListForm);

class ConfirmRecalcurateSummaryListFormModal extends React.Component {
  render() {
    const header = '再計算';
    const { isOpen, hideModal, laborInsuranceYear } = this.props;
    return (
      <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, laborInsuranceYear }}>
        <ConfirmRecalcurateSummaryListForm
          cancelBtnClick={hideModal}
          header={header}
          laborInsuranceYear={laborInsuranceYear}
        />
      </CommonModal>
    );
  }
}

export default ConfirmRecalcurateSummaryListFormModal;
